import { ApiRequestGet } from "../data/network/services/ApiRequestGet";
import { ApiRequestPost } from "../data/network/services/ApiRequestPost";
import {
  settlementCountSlice,
  transactionCountSlice,
  transactionVolumeCountSlice,
  updateClientBalanceSlice,
  updateClientVoucherBalanceSlice,
  updateMainTransactionSlice,
  updatePayoutClientBalanceSlice,
  updateRoleCountsSlice
} from "../data/redux/slice/countsSlice";
import {
  addApprovalList,
  addClientList,
  addClientListWithId,
  addCommissionList,
  addCustomerList,
  addPayoutTransactionList,
  addPedingList,
  addPrefundTransactionList,
  addResellerList,
  addRevenueList,
  addSettlementList,
  addTransactionList,
  addUserList,
  addVanTransactionList,
  clientPayinList,
  clientSecret,
  vanAccount,
  vanCustomer,
  vanAllCustomerList,
  addVoucherTransactionList,
  addCashfreeBal
} from "../data/redux/slice/listingDataSlice";
import { tableLoadingSlice } from "../data/redux/slice/loaderSlice";
import { SS_USER_HASH_ID } from "../utility/constants/secureStorageManager";
import {
  ACTIVE,
  APPROVED,
  STATUS_CODE_200,
  SUCCESS
} from "../utility/constants/valueConstants";
import secureStorage from "./secureStorage";

export const fecthResellerList =
  ({ page = 0, dateRange = "", size = 10, status, userId = "" }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchResellerList({
      page,
      dateRange,
      size,
      status,
      userId
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addResellerList(res?.data));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fecthClientList =
  ({
    page = 0,
    dateRange = "",
    size = 10,
    onBoardedStatus = "",
    activeStatus,
    userId = "",
    userRefId = "",
    serviceType = "",
    serviceProviderName = "",
    rootReferenceId = "",
    deactivatedList,
    businessName = ""
  }) =>
  (dispatch) => {
    console.log(
      {
        dateRange,
        size,
        onBoardedStatus,
        activeStatus,
        userId,
        userRefId,
        serviceType,
        serviceProviderName,
        rootReferenceId,
        deactivatedList
      },
      "data--------->>>>>>"
    );
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchClientList({
      page,
      dateRange,
      size,
      onBoardedStatus,
      activeStatus,
      userId,
      userRefId,
      serviceType,
      serviceProviderName,
      rootReferenceId,
      deactivatedList,
      businessName
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addClientList(res?.data));
        }
      })
      .catch((err) => {
        dispatch(tableLoadingSlice(false));
      })
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchTransactionList =
  ({
    page = 0,
    size = 10,
    dateRange,
    clientId,
    resellerId,
    status,
    serviceType,
    rootReferenceId,
    custRefNo,
    transactionId,
    serviceProviderName,
    van,
    mechanism
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchTransactionList({
      page,
      dateRange,
      size,
      clientId,
      resellerId,
      status,
      serviceType,
      rootReferenceId,
      custRefNo,
      transactionId,
      serviceProviderName,
      van,
      mechanism
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          if (serviceType?.toUpperCase() === "PAYOUT") {
            dispatch(addPayoutTransactionList(res?.data));
          } else if (serviceType?.toUpperCase() === "PREFUND") {
            dispatch(addPrefundTransactionList(res?.data));
          } else if (
            serviceType?.toUpperCase() === "VAN" ||
            serviceType?.toUpperCase() === "VAN-UPI"
          ) {
            dispatch(addVanTransactionList(res?.data));
          } else if (serviceType?.toUpperCase() === "VOUCHER") {
            dispatch(addVoucherTransactionList(res?.data));
          } else {
            dispatch(addTransactionList(res?.data));
          }
        } else {
          if (serviceType?.toUpperCase() === "PAYOUT") {
            dispatch(addPayoutTransactionList([]));
          } else if (serviceType?.toUpperCase() === "PREFUND") {
            dispatch(addPrefundTransactionList([]));
          } else if (
            serviceType?.toUpperCase() === "VAN" ||
            serviceType?.toUpperCase() === "VAN-UPI"
          ) {
            dispatch(addVanTransactionList([]));
          } else if (serviceType?.toUpperCase() === "VOUCHER") {
            dispatch(addVoucherTransactionList(res?.data));
          } else {
            dispatch(addTransactionList([]));
          }
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchSettlementList =
  ({
    page = 0,
    size = 10,
    dateRange = "",
    userId = "",
    userRefId = "",
    status = "",
    serviceType = ""
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchSettlementList({
      page,
      dateRange,
      size,
      userId,
      userRefId,
      status,
      serviceType,
      rootReferenceId: ""
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addSettlementList(res?.data));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchRevenueList =
  ({
    page = 0,
    size = 10,
    dateRange = "",
    userId = "",
    userRefId = "",
    status = "",
    serviceType = "",
    rootReferenceId = ""
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchRevenueList({
      page,
      dateRange,
      size,
      userId,
      userRefId,
      status,
      serviceType,
      rootReferenceId
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addRevenueList(res?.data));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };
export const fetchAllApprovalList =
  ({
    page,
    dateRange,
    size,
    onBoardedStatus,
    activeStatus,
    userId,
    userRefId,
    deactivatedList
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchClientList({
      page,
      dateRange,
      size,
      onBoardedStatus,
      activeStatus,
      userId,
      userRefId,
      deactivatedList
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addApprovalList(res?.data));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchAllPendngList =
  ({
    page,
    dateRange,
    size,
    onBoardedStatus,
    activeStatus,
    userId,
    userRefId
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchClientList({
      page,
      dateRange,
      size,
      onBoardedStatus,
      activeStatus,
      userId,
      userRefId
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addPedingList(res?.data));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const getAllDashboardVolumeCount =
  ({
    clientId = "",
    resellerId = "",
    rootReferenceId = "",
    dateRange = "",
    serviceProviderName = ""
  }) =>
  (dispatch) => {
    ApiRequestGet.getAllDashboardVolumeCount({
      clientId,
      resellerId,
      rootReferenceId,
      dateRange,
      serviceProviderName
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(
            transactionVolumeCountSlice({
              ...res?.data,
              lastUpdatedTime: res?.timestamp
            })
          );
        }
      })
      .catch((err) => {});
  };

export const getAllDashboardTransactionCount =
  ({
    clientId = "",
    resellerId = "",
    rootReferenceId = "",
    dateRange = "",
    serviceProviderName = ""
  }) =>
  (dispatch) => {
    ApiRequestGet.getAllDashboardTransactionCount({
      clientId,
      resellerId,
      rootReferenceId,
      dateRange,
      serviceProviderName
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(
            transactionCountSlice({
              ...res?.data,
              lastUpdatedTime: res?.timestamp
            })
          );
        }
      })

      .catch((err) => {});
  };

export const getAllSettlementCount =
  ({
    dateRange = "",
    userId = "",
    userRefId = "",
    serviceType = "",
    serviceProviderName = ""
  }) =>
  (dispatch) => {
    ApiRequestGet.getSettlementCount({
      dateRange,
      userId,
      userRefId,
      serviceType,
      serviceProviderName
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(
            settlementCountSlice({
              totalSettledAmount:
                res.data?.settledAmount[0]?.totalTransferAmount,
              totalUnsettledAmount:
                res.data?.unsettledAmount[0]?.totalTransferAmount,
              lastUpdated: res?.data?.settledAmount[0]?.lastUpdated
            })
          );
        }
      })
      .catch((err) => {});
  };

export const updateMainTransactions =
  ({ clientId = "", resellerId = "", rootReferenceId = "" }) =>
  (dispatch) => {
    ApiRequestGet.getAllDashboardVolumeCount({
      clientId,
      resellerId,
      rootReferenceId
    })

      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(
            updateMainTransactionSlice({
              ...res?.data
            })
          );
        }
      })
      .catch((err) => {});
  };

export const fetchAllRoleCounts = () => (dispatch) => {
  ApiRequestGet.getAllRoleCounts({ clientId: "" })
    .then((res) => {
      if (res.statusCode === STATUS_CODE_200) {
        dispatch(
          updateRoleCountsSlice({
            ...res?.data
          })
        );
      }
    })
    .catch((err) => {});
};
export const fetchAllCommissionList =
  ({ page, size }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getCommissionList({
      page,
      size
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(
            addCommissionList({
              ...res
            })
          );
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchAllClientIdist =
  ({ isForDropdown = "" }) =>
  (dispatch) => {
    ApiRequestGet.getClientListWithId({ isForDropdown })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addClientListWithId(res.data));
        }
      })
      .catch((err) => {});
  };

export const fetchAllUserList = (page, size) => (dispatch) => {
  dispatch(tableLoadingSlice(true));
  ApiRequestGet.getAllUserList(page, size)
    .then((res) => {
      if (res.statusCode === STATUS_CODE_200) {
        dispatch(addUserList(res.data));
      }
    })
    .catch((err) => {})
    .finally(() => {
      dispatch(tableLoadingSlice(false));
    });
};

export const fetchClientBalance =
  ({ clientId = "", resellerId = "", serviceProviderName = "" }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getClientBalance({
      id: clientId,
      userRefId: resellerId,
      serviceprovidername: serviceProviderName
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(updateClientBalanceSlice(res.data.balance));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };
export const fetchClientVoucherBalance =
  ({ clientId = "", resellerId = "", serviceProviderName = "" }) =>
  async (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getClientVouchertBalance({
      id: clientId,
      userRefId: resellerId,
      serviceprovidername: serviceProviderName
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(updateClientVoucherBalanceSlice(res.data.balance));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchClientPayoutBalance =
  ({ clientId = "", resellerId = "" }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getPayoutClientBalance({
      id: clientId,
      userRefId: resellerId
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(updatePayoutClientBalanceSlice(res.data.balance));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchClientBalanceWithIdFromSS =
  ({ id = "", userRefId = "" }) =>
  async (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getClientBalance({ id: id, userRefId: userRefId })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(updateClientBalanceSlice(res.data.balance));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchClientVoucherBalanceWithIdFromSS =
  ({ id = "", userRefId = "" }) =>
  async (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getClientVouchertBalance({ id: id, userRefId: userRefId })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(updateClientVoucherBalanceSlice(res.data.balance));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchPayoutClientBalanceWithIdFromSS =
  ({ id = "", userRefId = "" }) =>
  async (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getPayoutClientBalance({ id: id, userRefId: userRefId })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(updatePayoutClientBalanceSlice(res.data.balance));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchClientSecretId = () => async (dispatch) => {
  dispatch(tableLoadingSlice(true));
  ApiRequestGet.getSecretId({})
    .then((res) => {
      if (res.statusCode === STATUS_CODE_200) {
        dispatch(clientSecret(res.data));
      }
    })
    .catch((err) => {})
    .finally(() => {
      dispatch(tableLoadingSlice(false));
    });
};

export const fetchClientAccount =
  ({ id }) =>
  async (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestGet.getVanAccount({ id })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(vanAccount(res.data));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchVanTransaction =
  ({
    page,
    size,
    dateRange,
    business,
    keyWord,
    van,
    name,
    status,
    clientHashId,
    txnId,
    transferType,
    utr,
    programId,
    serviceType
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.getAllVanTransactionList({
      page,
      size,
      dateRange,
      business,
      keyWord,
      van,
      name,
      status,
      clientHashId,
      txnId,
      transferType,
      utr,
      programId,
      serviceType
    })
      .then((res) => {
        // dispatch(vanAccount(res.data));
        if (res?.data || res.status === SUCCESS) {
          dispatch(vanAccount(res?.data));
        }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };
export const fetchVanCustomer =
  ({
    page,
    size,
    dateRange,
    customerHashId,
    keyWord,
    van,
    name,
    status,
    clientHashId,
    programId,
    serviceType
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.getAllVanCustomerList({
      page,
      size,
      dateRange,
      customerHashId,
      keyWord,
      van,
      name,
      status,
      clientHashId,
      programId,
      serviceType
    })
      .then((res) => {
        console.log(res, "RESPONSE FROM UPI");
        dispatch(vanCustomer(res.data));
        // if (res && res.status === SUCCESS) {
        //   console.log(res, "RESPONSE FROM UPI");
        //   dispatch(vanCustomer(res.data));
        // }
      })
      .catch((err) => {})
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchCustomerList =
  ({ page = 0, size = 10, email, mobileNumber, status, upi }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.fetchCustomerList({
      page,
      size,
      email,
      mobileNumber,
      status,
      upi
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(addCustomerList(res?.data));
        }
      })
      .catch((err) => {
        dispatch(tableLoadingSlice(false));
      })
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const getVanCustomerList =
  ({
    page,
    size,
    dateRange,
    customerHashId,
    clientHashId,
    status,
    van,
    name,
    createdby,
    resellerId,
    serviceProviderName,
    email,
    mobileNumber
  }) =>
  (dispatch) => {
    dispatch(tableLoadingSlice(true));
    ApiRequestPost.getVanCustomerList({
      page,
      size,
      dateRange,
      customerHashId,
      clientHashId,
      status,
      van,
      name,
      createdby,
      resellerId,
      serviceProviderName,
      email,
      mobileNumber
    })
      .then((res) => {
        if (res.statusCode === STATUS_CODE_200) {
          dispatch(vanAllCustomerList(res?.data));
        }
      })
      .catch((err) => {
        dispatch(tableLoadingSlice(false));
      })
      .finally(() => {
        dispatch(tableLoadingSlice(false));
      });
  };

export const fetchCashfreeBalanceOfClient = (clientId) => (dispatch) => {
  console.log(clientId, "CLient id");
  ApiRequestGet.fetchCashfreeClientCurrentBalance({
    clientId
  })
    .then((res) => {
      if (res.statusCode === STATUS_CODE_200) {
        dispatch(addCashfreeBal(res?.data));
      }
    })
    .catch((err) => {
      console.log(err, "Error");
    });
};
